import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationBundle from './shared-pages/englishtranslation.json';
// englishtranslation.json is { "en": { "translation": { ... } } } — pass the inner `en` object to i18next
const resources = {
  en: translationBundle.en,
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'gr',

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
